import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { gridMargin } from './general';

export default class FormSwitch extends PureComponent {
	render() {
		const {label, value, path, onChange, gridProps} = this.props;

		const _onChange = event => {
			onChange(event.target.checked, path);
		};

		const content = (
			<FormControlLabel label={label} control={
				<Switch
					checked={value}
					onChange={_onChange}
					color="primary"
				/>
			}/>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs : 12 });
			return (<Grid item {...gridProps} style={gridMargin}>{content}</Grid>);
		} else {
			return content;
		}
	}
}

FormSwitch.propTypes = {
	label : PropTypes.string.isRequired,
	value : PropTypes.bool.isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,
	disabled : PropTypes.bool,
	gridProps : PropTypes.object,
};
